import { Inject, Injectable } from '@angular/core';

import { Actions, ofType, createEffect } from '@ngrx/effects';

import * as treeActions from '../actions/tree.action';

import { ApiService, BoilerPartService } from '@usimweb/core/services';
import { catchError, map, of, switchMap } from 'rxjs';
import { Env } from '@usimweb/core/models';

// import { environment } from '../../../../environments/environment';
// import { CacheService } from '../../../core/services/domain/cache/cache.service';

@Injectable()
export class TreeEffects {
  constructor(
    @Inject('environment') private environment: Env,
    private actions$: Actions,
    private apiService: ApiService, // private cacheService: CacheService
    private boilerPartService: BoilerPartService
  ) {}

  private DEBUG_TIME: number = this.environment.production === true ? 0 : 1000;
  private readonly DASHBOARD_EXPIRE_TIME = 1440 * 1;

  $loadVelaInput = createEffect(() => {
    return this.actions$.pipe(
      ofType(treeActions.LOAD_TREE_STRUCT),
      switchMap(() => {
        // const cached = this.cacheService.isCached(treeActions.LOAD_TREE_STRUCT);
        // if (cached) {
        //   const velaInput = this.cacheService.load(treeActions.LOAD_TREE_STRUCT);
        //   console.log('cached');
        //   console.log(velaInput);
        //   return of(new treeActions.LoadStructTreeSuccess(velaInput));
        // }

        return this.apiService.getVelaTemplates().pipe(
          map((templates) => {
            //set vela materials

            console.log('getVelaTemplates');
            console.log(templates);

            templates.forEach((template) => {
              const input_value = template.input_value as any;

              console.log('materials');
              console.log(template.materials);

              this.boilerPartService.setMaterials(template.materials);

              for (const [key, value] of Object.entries(template.materials)) {
                const obj1 = value as { [key: string]: any };

                for (const [key2, nestedArray] of Object.entries(obj1)) {
                  const parts = Array.isArray(input_value[key]) ? input_value[key] : [input_value[key]];

                  if (Array.isArray(parts)) {
                    parts.forEach((part) => {
                      // Check each property in the part
                      for (const [key3, values] of Object.entries(part)) {
                        if (Array.isArray(values)) {
                          // Update each layer in the array
                          values.forEach((layer: any) => {
                            layer[key2] = {
                              options: [...nestedArray],
                              ...nestedArray[0],
                            };
                          });
                        }
                      }

                      // Update material for each part
                      if (key !== 'patches') {
                        part[key2] = {
                          options: [...nestedArray],
                          ...nestedArray[0],
                        };
                      }
                    });
                  }
                }
              }
            });

            // this.cacheService.save({
            //   key: treeActions.LOAD_TREE_STRUCT,
            //   data: velaInput,
            //   expireTime: this.DASHBOARD_EXPIRE_TIME,
            // });

            console.log(templates);

            return new treeActions.LoadStructTreeSuccess(templates);
          }),
          catchError((error) => of(new treeActions.LoadStructTreeFail(error)))
        );
      })
    );
  });
}

// if (key === 'patches') {
//   parts.forEach((part) => {
//     if ('layers' in part) {
//       const layers = part['layers'];
//       layers.forEach((layer: any) => {
//         layer['material'] = {
//           options: [...nestedArray],
//           ...nestedArray[0],
//         };
//       });
//     }
//   });
// } else {
//   parts.forEach((part: any) => {
//     part[key2] = {
//       options: [...nestedArray],
//       ...nestedArray[0],
//     };
//   });
// }
